module.exports = __webpack_public_path__ + "static/media/banner_3.7a5e6426.jpg";